import React, {Component} from 'react';
import {connect} from 'react-redux';
import {ValidationService, StringService} from '../../services';
import {RouteKeys} from '../../constants';
import {InputText, ScreenNotificationDefault, Footer} from '../../components';
import validation from './validation';
import {redirectToDataDocument} from '../../ducks/Navigate';
import {
  updateEndereco,
  enderecoAdicionar,
  buscaCep,
} from '../../ducks/Customer';
import {cidadesBuscar, ufBuscar} from '../../ducks/Select';

import Select from 'react-select';
import {SelectStyles} from '../../constants';

import './styles.scss';

class DataResidential extends Component {
  async componentDidMount() {
    document.title = StringService.formatTitle(RouteKeys.DataResidential.title);
    this.props.ufBuscar();
    this.props.cidadesBuscar();

    this.setState({
      disabledNumero: this.props.endereco.numero === 'S/N' ? true : false,
    });
  }

  constructor(props) {
    super(props);
    this.state = {
      disabledBairro: true,
      disableNumero: false,
    };
  }

  formIsValid = () =>
    ValidationService.validate(this.props.endereco, validation);

  handleSubmit = (event) => {
    event.preventDefault();

    if (!this.formIsValid()) return;

    let chave = this.props.chave;
    const dados = {
      chave,
      ...this.props.endereco,
    };

    this.props.enderecoAdicionar(dados);
  };

  handleChange = (prop, value) => {
    if (prop.toLowerCase() === 'nonumber') {
      this.setState({disabledNumero: value});
      this.props.updateEndereco({prop: 'numero', value: value ? 'S/N' : ''});
    } else {
      this.props.updateEndereco({prop, value});
    }
  };

  buscarCep = (value) => {
    const isCepValid = value && value.replace(/[^0-9.]/g, '').length === 8;

    if (isCepValid) {
      this.props.buscaCep(value).then((address) => {
        if (address) {
          this.setState({disabledBairro: !!address.bairro});
        }
      });
    }
  };

  bloquearDigitoNumeroZero = (numero) => {
    return numero.toString() === '0' ? '' : numero;
  };

  selectCityOptions = (cidades, uf) => {
    return uf
      ? cidades
          .filter((cidade) => cidade.uf === uf)
          .map((cidade) => ({
            label: cidade.nome,
            value: cidade.nome,
          }))
      : null;
  };

  render() {
    return (
      <ScreenNotificationDefault
        title={<p>Qual o seu endereço residencial?</p>}
        contentCustom={
          <form className="form" id="frm" onSubmit={this.handleSubmit}>
            <div className="div-data-residential">
              <a
                href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                rel="noopener noreferrer"
                target="_blank"
              >
                Não sei meu cep
              </a>
            </div>

            <InputText
              id="cep"
              type="tel"
              name="cep"
              mask="99999-999"
              value={this.props.endereco.cep}
              onChange={(ev) => this.handleChange('cep', ev.target.value)}
              onBlur={(ev) => this.buscarCep(ev.target.value)}
              placeholder="CEP"
            />
            <InputText
              id="logradouro"
              name="logradouro"
              maxLength="30"
              value={this.props.endereco.logradouro}
              onChange={(ev) =>
                this.handleChange('logradouro', ev.target.value)
              }
              placeholder="Endereço"
            />

            <div className="form-group-numero">
              <InputText
                id="numero"
                type="tel"
                name="numero"
                maxLength="6"
                style={{width: '7em'}}
                disabled={this.state.disabledNumero ? 'disabled' : ''}
                value={this.props.endereco.numero}
                onChange={(ev) =>
                  this.handleChange(
                    'numero',
                    this.bloquearDigitoNumeroZero(ev.target.value),
                  )
                }
                placeholder="Número"
              />
              <div className="data-residential-checkBox-semNumero">
                <input
                  className="styled-checkbox"
                  id="NoNumber"
                  type="checkbox"
                  checked={this.props.endereco.numero === 'S/N' ? true : false}
                  onChange={(ev) =>
                    this.handleChange('noNumber', ev.target.checked)
                  }
                />
                <label htmlFor="NoNumber"></label>
                <label htmlFor="NoNumber" className="checkBox-label">
                  Sem Número
                </label>
              </div>
            </div>
            <InputText
              id="complemento"
              name="complemento"
              maxLength="15"
              value={this.props.endereco.complemento}
              onChange={(ev) =>
                this.handleChange('complemento', ev.target.value)
              }
              placeholder="Complemento"
            />
            <InputText
              id="bairro"
              name="bairro"
              maxLength="30"
              disabled={this.state.disabledBairro ? 'disabled' : ''}
              value={this.props.endereco.bairro}
              onChange={(ev) => this.handleChange('bairro', ev.target.value)}
              placeholder="Bairro"
            />

            <div className="form-group">
              <label htmlFor="uf" className="form-label">
                UF
              </label>

              <Select
                className="select-input"
                isSearchable={true}
                isClearable={true}
                isDisabled={true}
                id="uf"
                name="uf"
                required
                styles={SelectStyles}
                noOptionsMessage={() => 'Nenhuma opção encontrada'}
                placeholder="Selecione..."
                value={
                  this.props.endereco.uf
                    ? {
                        label: this.props.endereco.uf,
                        value: this.props.endereco.uf,
                      }
                    : ''
                }
                onChange={(ev) => {
                  this.handleChange('uf', ev ? ev.value : '');
                  this.handleChange('cidade', '');
                }}
                options={
                  this.props.ufs &&
                  this.props.ufs.map((uf, indice) => ({
                    label: uf.nome,
                    value: uf.nome,
                    key: indice,
                  }))
                }
              />
            </div>

            <div className="form-group">
              <label htmlFor="cidade" className="form-label">
                Cidade
              </label>
              <Select
                className="select-input"
                isSearchable={true}
                isClearable={true}
                required
                isDisabled={true}
                id="cidade"
                name="cidade"
                styles={SelectStyles}
                noOptionsMessage={() => 'Nenhuma opção encontrada'}
                placeholder="Selecione..."
                value={
                  this.props.endereco.cidade
                    ? {
                        label: this.props.endereco.cidade,
                        value: this.props.endereco.cidade,
                      }
                    : ''
                }
                onChange={(ev) => this.handleChange('cidade', ev.value)}
                options={this.selectCityOptions(
                  this.props.cidades,
                  this.props.endereco.uf,
                )}
              />
            </div>
          </form>
        }
        contentButtons={
          <div className="div-data-residential">
            <Footer
              backHandle={() => {
                this.props.redirectToDataDocument();
              }}
              nextForm="frm"
            />
          </div>
        }
      />
    );
  }
}

const mapStateToProps = ({customer, select}) => {
  const {chave, endereco} = customer;
  const {ufs, cidades} = select;

  return {chave, endereco, ufs, cidades};
};

export default connect(mapStateToProps, {
  redirectToDataDocument,
  updateEndereco,
  cidadesBuscar,
  ufBuscar,
  enderecoAdicionar,
  buscaCep,
})(DataResidential);
